import { BalanceType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

export type BulkCollectionsFilterStore = {
  balanceType: BalanceType[];
  searchValue: string;
  setBalanceType: (balanceTypes: BalanceType[]) => void;
  setSearchValue: (searchValue: string) => void;
  clearAll: () => void;
  clearFilters: () => void;
  clearSearch: () => void;
};

export const useBulkCollectionsFilterStore = createStoreWithSubscribe<BulkCollectionsFilterStore>(
  (set) => ({
    balanceType: [],
    searchValue: '',
    setBalanceType: (balanceTypes: BalanceType[]) => set({ balanceType: balanceTypes }),
    setSearchValue: (searchValue: string) => set({ searchValue }),
    clearAll: () => set({ balanceType: [], searchValue: '' }),
    clearFilters: () => set({ balanceType: [] }),
    clearSearch: () => set({ searchValue: '' }),
  }),
  {
    name: 'BulkCollectionsFilterStore',
    trace: true,
  }
);

export const useBulkCollectionsFilterShallowStore = createShallowStore(useBulkCollectionsFilterStore);
